// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","565":"component---src-templates-page-js","725":"component---src-templates-gallery-js"}[chunkId] || chunkId) + "-" + {"351":"18da0035233fc30357cd","565":"303ab71f11df5bb90a9e","725":"225edfdf8e3e92686e74","731":"c630501e759cb3f06436","843":"cff4afe7cadcd319a1bf"}[chunkId] + ".js";
};